import styled from "styled-components";

export const StyledParametersContainer = styled.div``;